const MAGIC_LINK_ERROR_MESSAGES = {
  INVALID_TOKEN: 'This sign-in link is invalid. Request a new magic link and try again.',
  EXPIRED_TOKEN: 'This sign-in link has expired. Request a new magic link to continue.',
  failed_to_create_user: 'We could not create your account from this link. Please try again.',
  failed_to_create_session: 'We could not start your session. Please request a new sign-in link.',
  new_user_signup_disabled: 'New account sign-up is currently disabled for this sign-in link.',
};

export function getMagicLinkErrorMessage(errorCode) {
  if (!errorCode || typeof errorCode !== 'string') {
    return '';
  }

  return MAGIC_LINK_ERROR_MESSAGES[errorCode] || 'Unable to verify sign-in link. Please request a new one.';
}
